export const URL_FUNCION =
  "/Seguridad/WebService/SeguridadWebService.asmx/BuscarFuncionesPorPerfil";
export const URL_ACTUALIZAR_FUNCIONES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarFuncionesPerfil";
export const URL_OBTENER_PERFILES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerPerfilesAImportar";
export const URL_IMPORTAR_PERFIL =
  "/Seguridad/WebService/SeguridadWebService.asmx/ImportarPerfil";
export const URL_OBTENER_USUARIO_LOGIN =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerUsuarioLogin";
export const URL_OBTENER_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerCompania";
export const URL_ACTUALIZAR_INFORMACION_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarInformacionCompania";

// Asistente interno de documentacion (CitrusGPT).
export const URL_CITRUSGPT_INICIAR_CHAT =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/IniciarChat";
export const URL_CITRUSGPT_ABRIR_CHAT =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/AbrirChat";
export const URL_CITRUSGPT_NUEVA_CONVERSACION =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/NuevaConversacion";
export const URL_CITRUSGPT_PREGUNTAR =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/Preguntar";
export const URL_CITRUSGPT_BUSCAR_CONVERSACIONES =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/BuscarConversaciones";

// Revision del conocimiento del asistente.
export const URL_CONOCIMIENTO_IA_INICIAR_REVISION =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/IniciarRevision";
export const URL_CONOCIMIENTO_IA_REGISTRAR_VEREDICTO =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/RegistrarVeredicto";
export const URL_CONOCIMIENTO_IA_GUARDAR_CORRECCIONES =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/GuardarCorreccionesDocumentacion";
export const URL_CONOCIMIENTO_IA_MARCAR_APLICADAS =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/MarcarCorreccionesAplicadas";
export const URL_CONOCIMIENTO_IA_BUSCAR_AMPLIACION =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/BuscarAmpliacion";
export const URL_CONOCIMIENTO_IA_AMPLIAR =
    "/Seguridad/WebService/CitrusGPTWebService.asmx/AmpliarConocimiento";

export const RUTA_CITRUSGPT = "/App/Seguridad/CitrusGPT";
export const RUTA_CONOCIMIENTO_IA_EDIT = "/App/Seguridad/ConocimientoIAEdit";
export const URL_CONOCIMIENTO_IA_LIST = "/Seguridad/conocimiento_ia_list.aspx";
    

